// The navbar's product list: whether the company has Cue at all.
const PRODUCT_ACCESS_PATH =
  '/api/servicesecurity/processes/users/productFeatureAccess';
// Cue's own per-user gate: the caller's `copilot#consume_credits` permission,
// then the company's Cue credit balance.
const CUE_GATE_CHECK_PATH =
  '/api/serviceorganizations/processes/companyCredits/gateCheck/cue';

type ProductAccessResponse = {
  data?: { productAccess?: Array<{ key: string; enabled: boolean }> };
};

type GateCheckResponse = { data?: { gated?: boolean } };

async function getJson<T>(url: string, token: string): Promise<T> {
  const response = await fetch(url, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error(`${url} answered ${response.status}`);
  return response.json() as Promise<T>;
}

/**
 * Whether this user may ask Cue a question: the company has Cue and the user
 * may spend Cue credits. Any failure reads as no, so Ask Cue stays hidden
 * rather than sending a question Cue would refuse.
 */
export async function fetchCanAskCue(
  wxApiUrl: string,
  token: string,
): Promise<boolean> {
  try {
    const [access, gate] = await Promise.all([
      getJson<ProductAccessResponse>(
        `${wxApiUrl}${PRODUCT_ACCESS_PATH}`,
        token,
      ),
      getJson<GateCheckResponse>(`${wxApiUrl}${CUE_GATE_CHECK_PATH}`, token),
    ]);
    const hasCue = (access.data?.productAccess ?? []).some(
      product => product.key === 'cue' && product.enabled,
    );
    return hasCue && gate.data?.gated === false;
  } catch {
    return false;
  }
}
